module.exports = __webpack_public_path__ + "img/tabo-dragon.ff08a354.png";